/** RFC 0345: the open sharing account, for whatever in the window shares. */
import type { openPersonalWorld } from '@mod/core/sharing'
import { createContext, useContext } from 'react'
import type { createSharingAccountClient, SharingAccount } from './account'

export interface OpenSharingAccount {
  opened: Awaited<ReturnType<typeof openPersonalWorld>>
  account: SharingAccount
  client: ReturnType<typeof createSharingAccountClient>
}

export const SharingAccountContext = createContext<
  OpenSharingAccount | undefined
>(undefined)

/** Undefined when sharing is off or the account has not opened. */
export const useSharingAccount = () => useContext(SharingAccountContext)
